import { Typography, Box } from '@mui/material';

const Footer = () => {
  return (
    <Box>
      <Typography color="#FFFFFF" className="qa-lynon">
        © Lynon 2026
      </Typography>
    </Box>
  );
};

export default Footer;
